/**
 * Capitalizes the first letter of a string.
 * @param text - The string to capitalize.
 * @returns The string with the first letter in uppercase.
 */
export function capitalize(text: string): string {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/**
 * Truncates a string if it exceeds a certain length.
 * @param text - The string to truncate.
 * @param maxLength - The maximum allowed length.
 * @returns The truncated string with "..." if needed.
 */
export function truncate(text: string, maxLength: number): string {
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}
